import miniToastr from 'mini-toastr'

var selected_device;
var devices = [];

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

export function setup() {

  BrowserPrint.getDefaultDevice("printer", function (device) {

    selected_device = device;
    devices.push(device);

    var html_select = document.getElementById("selected_device");
    var option = document.createElement("option");
    option.text = device.name;
    html_select.add(option);

    BrowserPrint.getLocalDevices(function (device_list) {
      for (var i = 0; i < device_list.length; i++) {

        var device = device_list[i];
        if (!selected_device || device.uid != selected_device.uid) {
          devices.push(device);
          var option = document.createElement("option");
          option.text = device.name;
          option.value = device.uid;
          html_select.add(option);
        }
      }

    }, function () {

      miniToastr.info("Error al obtener los dispositivos locales.", "");

    }, "printer");

  }, function (error) {

    miniToastr.info("Error al detectar la impresora.", "");

  })


}


export function Printer(dataToWrite, typeLabel, numbrePrint) {

  //Etiqueta  pulgadas - 10 x 7 cm

  if (typeLabel == 1) {

    //console.log("%o",dataToWrite);

    selected_device.send("^XA\
    ^FO40,50^GFA,2904,2904,33,hR01FF,7OF8gY01LF,7OF8gY05LF,7PFgY0MFE4,7PFCgW07FFE03IFC,78M07FF8gV0FFCJ0IFC,78N07F8gU07FCL0FF8,78N01FEgT02FFM03FE,78O07FgT05FCN07F8,78O03FgS01FFO03FD,78P0FCgS0FEP0FE8,78P0FCgR01F8P03FC,78P07CgR03FQ01FE,78P03EgR07ER0FF,78P03EgR0F8R07F8,78P01FgQ01FS03F,78P01F8P01CIF78S03ES01F8,78Q0FQ08KF8S07CT0FC,78Q0F8KFEJ0RFCI01JF8T07E,78Q0F9KFEI07RFCI01JF8T03F,78Q0F9LF8007FEI0NFI01JFU01F,78Q0NF001FFK0MFI01IFEV0F8,78J03CK07FCI01F007F8K03EI01F8001EY0F8,78J07FK07FCJ0F00FEM06J0FD001EY07C,78J07F8J07F8J0FC1F8R07E001EY07C,78J07F8J07F8J0783FS03F001EY03F,78J07F8J07F8J07C7CS01F001EO07FFM03E,78J07F8J0FFK07CF8S01FC01EN01IFEL01E,78J07F8J0FFK03FFU0FC01EN07JFL01F8,78J07F8J0FEK03FEU07E01EN0KFCK01F8,78J07FK0FEK03FCU03E01EM01KFEL0F8,78J03EK0FEK01F8U01F01EM03LFL0F8,78P01FCK01F8V0F81EM07LF8K0F8,78P01FCK01FW0FE1EM07LF8K078,78P03FCL0EW07F1EM0MFCK078,78P07F8L0EL0EP03F1EM0MFCK07C,78P07F8L04K0FFEO01F3EL01MFEK07C,78P0FFR01IFO01FFEL01MFEK07C,78P0FFR07IF8O0FFEL03MFEK07C,78P03FR0JFCO07FEL03NFK07C,78Q0ER0JFEO03FEL03NFK07C,78Q06Q01JFEO01FEL03NFK07C,78gI01KF0EN0FEL03NFK07C,78gI03KFBEN0FEL03NFK07C,78gI03LFEN07EL03NFK07C,784K018004K01K083FF8N010083EK043NF040087C,784O0104002L087FFS01EK043NFJ087C,784008M084002L087FFM01L0EK043NFJ087C,784008M084003L087FFM01002I0E1J043MFEJ087C,7840083F004008410704I0187FFM0100303061J041MFE180187C,787FF87FF07KF0707JF87FF0MF0C1FF801JFE1MFE1IF87C,787FF87FF83KF0F87JF87FF07LF0C1FF801JFE1MFC1IF078,787FF87FF83KF0F83JF87FF07LF0E0FFC01JFE0MFC3IF0F8,787FF87FFC3JFE0F83JF87FF0MF0F07FE01JFE07LF83IF0F8,787FF87FFC3JFE0F83JF87FF0MF0F83FF01KF87LF83IF0F8,787FF87FFC3JFEI03JF83FFI03JF0F83FF81KF83LF07IF0F,787FF87FFC3JFEI01JF83FFJ0JF0FC1FFC1KFC1KFE0IFE1F8,787FF87FF83JFCI01JFC3FFJ0JF0FE0FFC1KFC0KFC1IFE1F8,787FF87FF83JFEI01JFC1FFJ0JF0FF07FE1KFE07JF83IFC1E,787FF87FF07SFE1JFC0JF0FF87FF1LF01IFE03IFC3E,787FF83FC0TFE0JFE1JF0FF83OFC07FF80JF83E,787FF8I01UF07IFC1JF0FFC1OFE007801JF87C,787FF8I03UF03IFC3JF0FFE0PFK03JF07C,787FFCI07UF81IF83JF0FBF07OFCJ0KF0FC,787FFC007VFC07FC07JF0F9F87JF1KF8007JFE0F8,787RFK07JFEK0KF0F8F83JF1LFCLFC1F,787RFK03KFJ01KF0F87C1JF0SFC3F8,787QFEK03KFCI07KF0F87E0JF07RF83E,787QFEK03LF803LF0F87F07IF03RF07E,787QFC1IFE1RF3FF0F81F07IF01QFE0FC,787QFC3IFE1FFDNFE1FF0F82F83IF00QFC1FC,787QF87IFE1FF87MF83FF0F817C1IF007PF83F,787QF87JF0FFC1MF03FF0F807E0IF001OFE07F,78NFE3FF87JF0FFC0LFC03FF0F807F0IF0C0OFC0FE,787KFE001FF0FE01F87FC01KF001FF0F805F07FF0E03NF81FC,78S0F80078K01IFM0F800F8J0F80MFC03F8,78R01FI078Q0EJ0F8007CJ0FC03LF00FF,78R01F8007CP03EJ0F8007EJ0FE007JFC01FE,7TFEI0MFJ01MF8003MF8003FFI07FF,7TFE8007MF001NF8001NFM01FF8,7TFEI03XF8001NFCL0FFE,7TFCI01XF8I07NF8J07FF8,7TFEI01XFJ03KF6JF01IFE8,gL0KF8W07NFC,gM01FCg0MFE4,hP04KFE4,hQ0KFE,,^FS\
    ^FX Top section with logo, name and address.\
    ^CF0,40\
    ^FO350,60^FDRECEPCION DE FRUTA^FS\
    ^CF0,30\
    ^FO400,120^FDFECHA:" + fechaActual()+ "^FS\
    ^CF0,40\
    ^FO40,160^FD"+eliminarDiacriticos(dataToWrite.code)+"^FS\
    ^CF0,35\
    ^FO40,205^FD"+eliminarDiacriticos(dataToWrite.description)+"^FS\
    ^FO170,250^A0N,32,32^FB500,1,0,C^FDGUIA:"+eliminarDiacriticos(dataToWrite.document_number)+"^FS\
    ^FX Second section with recipient address and permit information.\
    ^CFA,25\
    ^FO50,300^FD"+eliminarDiacriticos(dataToWrite.quantity)+" "+eliminarDiacriticos(dataToWrite.container.text)+" "+eliminarDiacriticos(dataToWrite.container.net_weight)+" KG^FS\
    ^FO50,340^FDLOTE "+eliminarDiacriticos(dataToWrite.lot)+"^FS\
    ^FO50,380^FD"+eliminarDiacriticos(dataToWrite.pallet_type)+"^FS\
    ^FO50,420^FDPESO BRUTO "+eliminarDiacriticos(dataToWrite.gross_weight)+" KG^FS\
    ^FO50,460^FDPESO NETO "+eliminarDiacriticos(dataToWrite.net_weight)+" KG^FS\
    ^FO530,280^BY4,2.0,65^BQ,2,09^FDQA,"+eliminarDiacriticos(dataToWrite.number)+"^FS\
    ^FO50,500^GB700,1,3^FS\
    ^PQ" + numbrePrint + "\
    ^XZ", undefined, errorCallback);

  }
  
  
}

export function PrintPallet(dataToWrite, numbrePrint,typeLabel) {

  
   // Etiqueta Arandano
  if(typeLabel==1)
  {

    var detalles = "";

  var cordy1 = 440;
  var cordy2 = 470;
  var cordy3 = 500;
  var cordy4 = 540;

  var total_cantidad = 0;

    for (var i = 0; i < dataToWrite.contents.length; i++) {

      detalles += "^CF0,28\
      ^FO50," + cordy1 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].origin) +"^FS\
      ^FO50," + cordy2 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].plant) + " ^FS\
      ^FO50," + cordy3 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].variety_name)
        + " - " + formato(dataToWrite.contents[i].creation_date)
        + " - " + eliminarDiacriticos2(dataToWrite.contents[i].string_specs) + "^FS\
      ^CF0,50\
      ^FO710," + cordy2 + "^FD" + dataToWrite.contents[i].quantity + "^FS\
      ^FO50," + cordy4 + "^GB750,1,1^FS";

      total_cantidad += parseInt(dataToWrite.contents[i].quantity);

      cordy1 = cordy1 + 130;
      cordy2 = cordy2 + 130;
      cordy3 = cordy3 + 130;
      cordy4 = cordy4 + 130;
    }

      selected_device.send("^XA\
			^FX Top section with company logo, name and address.\
			^CF0,150\
      ^FO50,20^FD" + dataToWrite.number + "^FS\
      ^FO585,187^BY4,2.0,65^BQ,2,4^FDQA,"+dataToWrite.number+"^FS\
			^CF0,60\
			^FO45,170^FD"+dataToWrite.client_customer+"^FS\
			^CF0,40\
			^FO50,240^GB750,1,3^FS\
			^CF0,45\
			^FO50,255^FD" + eliminarDiacriticos(dataToWrite.contents[0].container.text) + "^FS\
			^FO50,295^FD" + eliminarDiacriticos(dataToWrite.contents[0].condition) + "^FS\
			^FO50,335^FD" + eliminarDiacriticos(dataToWrite.contents[0].product_type_name) + "^FS\
			^CF0,40\
			^FO50,380^GB750,1,3^FS\
			^FO50,420^GB750,1,3^FS\
			^CF0,35\
			^FO50,395^FDDETALLE^FS\
			^FO638,395^FDCANTIDAD^FS\
			^FX Seccion de detalle segun SAG\
			" + detalles + "\
			^CF0,100\
			^FO50," +cordy1+ "^FDTotal:" + total_cantidad+"^FS\
			^FX  section with barcode.\
			^BY2,2,100\
			^FX Cantidada de etiquetas.\
			^PQ" + numbrePrint + "\
			^XZ", successCallback, errorCallback);

  }


  // Etiqueta tipo 2 
  if(typeLabel==2)
  {

  var detalles = "";

  var cordy1 = 440;
  var cordy2 = 480;
  var cordy3 = 520;
  var cordy33 = 560;
  var cordy4 = 600;
  

  var total_cantidad = 0;
  

    for (var i = 0; i < dataToWrite.contents.length; i++) {

      detalles += "^CF0,40\
      ^FO50," + cordy1 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].origin) +"^FS\
      ^FO50," + cordy2 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].plant) + " ^FS\
      ^FO50," + cordy3 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].variety_name)
        + " - " + formato(dataToWrite.contents[i].creation_date)+ " ^FS\
      ^CF0,30\
      ^FO50," + cordy33 + "^FD" + eliminarDiacriticos2(dataToWrite.contents[i].string_specs) + " ^FS\
      ^CF0,50\
      ^FO710," + cordy2 + "^FD" + dataToWrite.contents[i].quantity + "^FS\
      ^FO50," + cordy4 + "^GB750,1,1^FS";

      total_cantidad += parseInt(dataToWrite.contents[i].quantity);

      cordy1 = cordy1 + 170;
      cordy2 = cordy2 + 170;
      cordy3 = cordy3 + 170;
      cordy33 = cordy33 + 170;
      cordy4 = cordy4 + 170;
    }

      selected_device.send("^XA\
			^FX Top section with company logo, name and address.\
			^CF0,150\
			^FO50,20^FD" + dataToWrite.number + "^FS\
			^FO585,187^BY4,2.0,60^BQ,2,5^FDQA,"+dataToWrite.number+"^FS\
			^CF0,45\
			^FO45,170^FD"+dataToWrite.client_customer+"^FS\
			^CF0,40\
			^FO50,240^GB750,1,3^FS\
			^CF0,45\
			^FO50,255^FD" + eliminarDiacriticos(dataToWrite.contents[0].container.text) + "^FS\
			^FO50,295^FD" + eliminarDiacriticos(dataToWrite.contents[0].condition) + "^FS\
			^FO50,335^FD" + eliminarDiacriticos(dataToWrite.contents[0].product_type_name) + "^FS\
			^CF0,40\
			^FO50,380^GB750,1,3^FS\
			^FO50,420^GB750,1,3^FS\
			^CF0,40\
			^FO50,388^FDDETALLE^FS\
			^FO638,388^FDCANTIDAD^FS\
			^FX Seccion de detalle segun SAG\
      " + detalles + "\
      ^CF0,80\
      ^FO50," +cordy1+ "^FDTotal:" +total_cantidad+"^FS\
      ^FO50," +(parseInt(cordy1)+parseInt(70))+ "^FDTotal KG:" +dataToWrite.total_net_kilograms+"^FS\
			^FX  section with barcode.\
			^BY2,2,100\
			^FX Cantidada de etiquetas.\
			^PQ" + numbrePrint + "\
			^XZ", successCallback, errorCallback);

  }




  // Etiqueta tipo 3 
  if(typeLabel==3)
  {

  var detalles = "";

  var cordy1 = 440;
  var cordy2 = 480;
  var cordy3 = 520;
  var cordy33 = 560;
  var cordy4 = 600;
  

  var total_cantidad = 0;
  var total_kilogramos = '';

 
  if (dataToWrite.contents[0].container.value.bulk == true ){
    total_kilogramos = ' KG: ' + dataToWrite.total_net_kilograms;
  }


    for (var i = 0; i < dataToWrite.contents.length; i++) {

      detalles += "^CF0,40\
      ^FO50," + cordy1 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].origin) +"^FS\
      ^FO50," + cordy2 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].plant) + " ^FS\
      ^FO50," + cordy3 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].variety_name)
        + " - " + formato(dataToWrite.contents[i].creation_date)+ " ^FS\
      ^CF0,30\
      ^FO50," + cordy33 + "^FD" + eliminarDiacriticos2(dataToWrite.contents[i].string_specs) + " ^FS\
      ^CF0,50\
      ^FO710," + cordy2 + "^FD" + dataToWrite.contents[i].quantity + "^FS\
      ^FO50," + cordy4 + "^GB750,1,1^FS";

      total_cantidad += parseInt(dataToWrite.contents[i].quantity);

      cordy1 = cordy1 + 170;
      cordy2 = cordy2 + 170;
      cordy3 = cordy3 + 170;
      cordy33 = cordy33 + 170;
      cordy4 = cordy4 + 170;
    }

      selected_device.send("^XA\
			^FX Top section with company logo, name and address.\
			^CF0,150\
			^FO50,20^FD" + dataToWrite.number + "^FS\
			^FO585,187^BY4,2.0,65^BQ,2,4^FDQA,"+dataToWrite.number+"^FS\
			^CF0,45\
			^FO45,170^FD"+dataToWrite.client_customer+"^FS\
			^CF0,40\
			^FO50,240^GB750,1,3^FS\
			^CF0,45\
			^FO50,255^FD" + eliminarDiacriticos(dataToWrite.contents[0].container.text) + "^FS\
			^FO50,295^FD" + eliminarDiacriticos(dataToWrite.contents[0].condition) + "^FS\
			^FO50,335^FD" + eliminarDiacriticos(dataToWrite.contents[0].product_type_name) + "^FS\
			^CF0,40\
			^FO50,380^GB750,1,3^FS\
			^FO50,420^GB750,1,3^FS\
			^CF0,40\
			^FO50,388^FDDETALLE^FS\
			^FO638,388^FDCANTIDAD^FS\
			^FX Seccion de detalle segun SAG\
      " + detalles + "\
      ^CF0,90\
			^FO50," +cordy1+ "^FD" +total_kilogramos+"^FS\
			^FX  section with barcode.\
			^BY2,2,100\
			^FX Cantidada de etiquetas.\
			^PQ" + numbrePrint + "\
			^XZ", successCallback, errorCallback);

  }



  // Etiqueta tipo 4
  if(typeLabel==4)
  {

  var detalles = "";

  var cordy1 = 445;
  var cordy2 = 520;
  var cordy3 = 580;
  var cordy33 = 655;
  var cordy4 = 730;
  

  var total_cantidad = 0;
  

    for (var i = 0; i < dataToWrite.contents.length; i++) {

      detalles += "^CF0,70\
      ^FO50," + cordy1 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].origin) +"^FS\
      ^CF0,50\
      ^FO50," + cordy2 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].plant) + " ^FS\
      ^CF0,70\
      ^FO50," + cordy3 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].variety_name)
        + " - " + formato(dataToWrite.contents[i].creation_date)+ " ^FS\
      ^CF0,70\
      ^FO50," + cordy33 + "^FD" + eliminarDiacriticos2(dataToWrite.contents[i].string_specs) + " ^FS\
      ^CF0,70\
      ^FO50," + cordy4 + "^GB750,1,1^FS";

      total_cantidad += parseInt(dataToWrite.contents[i].quantity);

      cordy1 = cordy1 + 305;
      cordy2 = cordy2 + 305;
      cordy3 = cordy3 + 305;
      cordy33 = cordy33 + 305;
      cordy4 = cordy4 + 305;
    }

      selected_device.send("^XA\
			^FX Top section with company logo, name and address.\
			^CF0,150\
			^FO50,20^FD" + dataToWrite.number + "^FS\
			^FO585,187^BY4,2.0,60^BQ,2,5^FDQA,"+dataToWrite.number+"^FS\
			^CF0,45\
			^FO45,170^FD"+dataToWrite.client_customer+"^FS\
			^CF0,40\
			^FO50,240^GB750,1,3^FS\
			^CF0,45\
			^FO50,255^FD" + eliminarDiacriticos(dataToWrite.contents[0].container.text) + "^FS\
			^FO50,295^FD" + eliminarDiacriticos(dataToWrite.contents[0].condition) + "^FS\
			^FO50,335^FD" + eliminarDiacriticos(dataToWrite.contents[0].product_type_name) + "^FS\
			^CF0,40\
			^FO50,380^GB750,1,3^FS\
			^FO50,420^GB750,1,3^FS\
			^CF0,35\
			^FO50,388^FDDETALLE^FS\
			^FX Seccion de detalle segun SAG\
      " + detalles + "\
      ^CF0,80\
      ^FO50," +cordy1+ "^FDTotal:" +total_cantidad+"^FS\
      ^FO50," +(parseInt(cordy1)+parseInt(80))+ "^FDTotal KG:" +dataToWrite.total_net_kilograms+"^FS\
			^FX  section with barcode.\
			^BY2,2,100\
			^FX Cantidada de etiquetas.\
			^PQ" + numbrePrint + "\
			^XZ", successCallback, errorCallback);

  }




   // Etiqueta tipo 5
   if(typeLabel==5)
   {
 
   var detalles = "";
 
   var cordy1 = 445;
   var cordy2 = 520;
   var cordy3 = 580;
   var cordy33 = 655;
   var cordy4 = 730;
   
 
   var total_cantidad = 0;
   
 
     for (var i = 0; i < dataToWrite.contents.length; i++) {
 
       detalles += "^CF0,70\
       ^FO50," + cordy1 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].origin) +"^FS\
       ^CF0,50\
       ^FO50," + cordy2 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].plant) + " ^FS\
       ^CF0,70\
       ^FO50," + cordy3 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].variety_name)
         + " - " + formato(dataToWrite.contents[i].creation_date)+ " ^FS\
       ^CF0,70\
       ^FO50," + cordy33 + "^FD" + eliminarDiacriticos2(dataToWrite.contents[i].string_specs) + " ^FS\
       ^CF0,70\
       ^FO50," + cordy4 + "^GB750,1,1^FS";
 
       total_cantidad += parseInt(dataToWrite.contents[i].quantity);
 
       cordy1 = cordy1 + 305;
       cordy2 = cordy2 + 305;
       cordy3 = cordy3 + 305;
       cordy33 = cordy33 + 305;
       cordy4 = cordy4 + 305;
     }
 
       selected_device.send("^XA\
       ^FX Top section with company logo, name and address.\
       ^CF0,150\
       ^FO50,20^FD" + dataToWrite.number + "^FS\
       ^FO585,187^BY4,2.0,60^BQ,2,5^FDQA,"+dataToWrite.number+"^FS\
       ^CF0,45\
       ^FO45,170^FD"+dataToWrite.client_customer+"^FS\
       ^CF0,40\
       ^FO50,240^GB750,1,3^FS\
       ^CF0,45\
       ^FO50,255^FD" + eliminarDiacriticos(dataToWrite.contents[0].container.text) + "^FS\
       ^FO50,295^FD" + eliminarDiacriticos(dataToWrite.contents[0].condition) + "^FS\
       ^FO50,335^FD" + eliminarDiacriticos(dataToWrite.contents[0].product_type_name) + "^FS\
       ^CF0,40\
       ^FO50,380^GB750,1,3^FS\
       ^FO50,420^GB750,1,3^FS\
       ^CF0,35\
       ^FO50,388^FDDETALLE^FS\
       ^FX Seccion de detalle segun SAG\
       " + detalles + "\
       ^CF0,80\
       ^FO50," +cordy1+ "^FDENVASES:" +total_cantidad+"^FS\
       ^FO50," +(parseInt(cordy1)+parseInt(80))+ "^FDUN:" +dataToWrite.total_net_kilograms+"^FS\
       ^FX  section with barcode.\
       ^BY2,2,100\
       ^FX Cantidada de etiquetas.\
       ^PQ" + numbrePrint + "\
       ^XZ", successCallback, errorCallback);
 
   }

  

};


function errorCallback(errorMessage) {

  miniToastr.info("Problemas al realizar la operación", "");

}


export function successCallback(successMessage) {

  miniToastr.info("Impresión realizada con éxito.", "");

}


function formato(texto) {
  return texto.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1');
}

function eliminarDiacriticos(texto) {

  if(texto===null)
  {
    return "Sin informacion";
  }else{
    return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
  }
  
}


function eliminarDiacriticos2(texto) {

  if(texto===null)
  {
    return "Sin informacion";
  }else{
    let textAux =  texto.split("~").join("-");
    return textAux.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
  }
  
}


function fechaActual() {

  let date = new Date()

let day = date.getDate()
let month = date.getMonth() + 1
let year = date.getFullYear()

if(month < 10){
  return (`${day}-0${month}-${year}`);
}else{
  return (`${day}-${month}-${year}`);
}


}
